<template>
  <div class="page">
    <PageHeader title="Platform Admin" :description="route.meta.description" :tabs="tabs" />
    <router-view />
  </div>
</template>

<script lang="ts" setup>
import PageHeader from '@shared/components/pageHeader/PageHeader.vue';
import { computed } from 'vue';
import { TabItem } from '@shared/components/pageHeader/tabItem';
import { useRoute } from 'vue-router';

const route = useRoute();
const isWorkspaceOpen = computed(() => String(route.name).startsWith('platform-admin-workspace-edit'));

const tabs = computed<TabItem[]>(() => {
  if (!isWorkspaceOpen.value) {
    return [];
  }
  return [
    { name: 'Apps & Features', route: 'platform-admin-workspace-edit' },
    { name: 'Users', route: 'platform-admin-workspace-edit-users' },
  ];
});
</script>
